import { EligibleProfessional } from "@/domain/entities/EligibleProfessional";
import { Professional } from "@/domain/entities/Professional";
import moment from "moment";
import { PROFESSIONAL_REJECTION_STEP_LABELS } from "../constants/professionalRejectionStepLabels";
import { EligibleProfessionalViewModel } from "../viewmodels/EligibleProfessionalViewModel";
import { ProfessionalViewModel } from "../viewmodels/ProfessionalViewModel";
import buildApprovalStatusBadge from "./professionalApprovalStatusBadge";
import WorkingHourPresentationMappers from "./WorkingHourPresentationMappers";

const toViewModel = (professional: Professional): ProfessionalViewModel => {
    return {
        ...professional,
        statusBadge: buildApprovalStatusBadge(professional.approved),
        rejectionStepLabel: professional.rejection_step ? PROFESSIONAL_REJECTION_STEP_LABELS[professional.rejection_step] : null,
        formattedPrice: professional.price
            ? new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(professional.price))
            : null,
        formattedSpecialty: professional.specialty_name || "N/I",
        formattedSubmittedAt: professional.submitted_at
            ? moment(professional.submitted_at).format("DD/MM/YYYY [às] HH:mm")
            : null,
        // já vêm como URL completa desde o mapper de infra (ver
        // ProfessionalDataMappers.toDomain) — não precisa mais prefixar.
        officialDocumentPhotoUrl: professional.official_document_photo,
        specialistCertificateUrl: professional.specialist_certificate,
        selfiePhotoUrl: professional.selfie_photo,
        professionalCardFrontUrl: professional.professional_card_front,
        professionalCardBackUrl: professional.professional_card_back,
        formattedProfessionalCardDocumentType: professional.professional_card_document_type
            ? professional.professional_card_document_type.toUpperCase()
            : null,
        workingHours: WorkingHourPresentationMappers.toListViewModel(professional.working_hours),
    }
}

const toEligibleViewModel = (item: EligibleProfessional): EligibleProfessionalViewModel => {
    console.log(item.rejection_step ? PROFESSIONAL_REJECTION_STEP_LABELS[item.rejection_step] : "")
    return {

        ...item,
        statusBadge: buildApprovalStatusBadge(item.approved),
        formattedRejectionStep: item.rejection_step ? PROFESSIONAL_REJECTION_STEP_LABELS[item.rejection_step] : "",
    }
}

const toEligibleListViewModel = (items: EligibleProfessional[]): EligibleProfessionalViewModel[] =>
    (items || []).map(toEligibleViewModel)

export default { toViewModel, toEligibleViewModel, toEligibleListViewModel }
